/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { AxiosResponse } from "axios";
import { Dispatch } from "react";
import { AnyAction } from "@reduxjs/toolkit";
import { deleteHandler, getHandlerVersionCaching, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { Company, CreateCompanyRequest, Effect, Setter, VersionedPagination } from "../../utils/Interfaces";
import { setExistingCompanies } from "./companiesSlice";
import { store } from "../../app/store";

export function editCompany(companyId: number, newName: string, dispatch: Dispatch<AnyAction>, onRefreshCompanies: Effect) {
    postHandler(
        `/api/companies/edit/${companyId}`,
        { name: newName },
        dispatch,
        () => {
            onRefreshCompanies();
        },
        stdErrHandlerFactory(dispatch),
        (isLoading) => {}
    );
}

export function deleteCompany(companyId: number, dispatch: Dispatch<AnyAction>, onRefreshCompanies: Effect) {
    deleteHandler(
        `/api/companies/delete/${companyId}`,
        dispatch,
        () => {
            onRefreshCompanies();
        },
        stdErrHandlerFactory(dispatch),
        (isLoading) => {}
    );
}

export function updateCompanies(dispatch: Dispatch<AnyAction>, setLoading: Setter<boolean>) {
    getHandlerVersionCaching<Company>(
        "/api/companies/list",
        store.getState().companies.companiesVersion,
        dispatch,
        (response: AxiosResponse<VersionedPagination<Company>>) => {
            dispatch(setExistingCompanies(response.data));
        },
        () => {},
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function createCompany(newCompany: CreateCompanyRequest, dispatch: Dispatch<AnyAction>, onCompanyCreated: Effect) {
    postHandler(
        "/api/companies/create",
        newCompany,
        dispatch,
        () => {
            onCompanyCreated();
        },
        stdErrHandlerFactory(dispatch),
        (isLoading) => {}
    );
}

export function companyNameExists(newCompanyName: string, companies: Company[]): boolean {
    let processedCompanyName: string = newCompanyName.trim();
    return companies.filter((elem) => elem.name === processedCompanyName).length > 0;
}
